import React from 'react';
import { PlatformKBWithContext } from '@wealthlane/chatbot';
import { axiosInstance } from '../../services/apiInterceptor';
import { useGetCurrentTenantInfo, useWealthlaneCustomerApi } from '../../hooks';
import { toast } from 'react-toastify';
import Heading from '../typography';
import { PageHeader } from '../../constants/style/common.styled';
import ToastComponent from '../toast';
import useInstance from '../../hooks/custom-hooks/useInstance';

type TChatConfig = {
  responseProtocol: string;
  responseType: string;
  endpoint?: string;
  timeout?: number;
  ingestionEndpoint?: string;
  disclaimer?: string;
};

const configState: TChatConfig = {
  responseProtocol: 'websocket' as const as string,
  responseType: 'stream' as const as string,
  endpoint: process.env.REACT_APP_CHATBOT_WEBSOCKET_API,
  timeout: 30000,
  ingestionEndpoint: process.env.REACT_APP_INGESTION_ENDPOINT,
};

export function PlatformKB() {
  const { handleRequest } = useWealthlaneCustomerApi();
  const { data: currentTenantInfo } = useGetCurrentTenantInfo(handleRequest);
  const { getCurrentCid } = useInstance();
  const cid = getCurrentCid();
  const apiBase =
    process.env.REACT_APP_PLATFORM_KB_API ||
    (process.env.REACT_APP_CHATBOT_REST_URL
      ? `${process.env.REACT_APP_CHATBOT_REST_URL}/api/kb`
      : '');

  return (
    <>
      <PageHeader>
        <Heading variant="h3" title="Platform Knowledge Base" id="platform-kb" />
        <Heading
          variant="body-s"
          title="Manage platform how-to guides, deep links, and content gaps."
          id="platform-kb-subtitle"
        />
      </PageHeader>

      <PlatformKBWithContext
        axiosInstance={axiosInstance}
        config={configState}
        companyId={cid?.toString?.() ?? ''}
        tenantIdAccessor={() => currentTenantInfo?.id}
        alertFunctionSuccess={(message: string) =>
          toast.success(<ToastComponent label="Success" message={message} />)
        }
        alertFunctionError={(message: string) =>
          toast.error(<ToastComponent label="Error" message={message} />)
        }
        apiBase={apiBase}
      />
    </>
  );
}

export default PlatformKB;
